export const STIFFNESS = 100;
export const DAMPING = 20;
export const MASS = 3;
export const SWIPE_POWER = 300;
export const FULL_PERCENTAGE = 100;
export const EXTRA_ITEM_PERCENTAGE = 0.2;
export const DRAG_CONSTRAINTS = 500;
export const DRAG_ELASTIC = 0.2;
export const PADDING_RIGHT = 8;
export const ANIMATE_TRANSLATE_ITEMS = 2;
export const ANIMATE_X_TRANSLATE_SHORT = 90;
export const ANIMATE_X_TRANSLATE_LONG = 220;
